import { http } from "../http";
import { Params } from "@/facilities/model/user";
import { TABLEPAI } from "@/enums/pageEnum";

export const creatScedule = async (params: Params) => {
  return await http.post("/api/lm-lift-schedule", params);
};

export const getDescrScedule = async (params?: Params) => {
  return await http.get(`${TABLEPAI.LM_SCHEDULE}/description`, {
    params,
  });
};

export const getLiftAddress = async (name: string) => {
  return await http.get("/api/building", {
    params: { name },
  });
};

export const getLiftCompany = async (params?: Params) => {
  return await http.get("/api/lift", {
    params,
  });
};

export const editCheckerRemaker = async (params?: Params) => {
  return await http.put(TABLEPAI.LM_CHECKER, params);
};
